import Imagens from "../../../components/IMAGESCOMPONENT/ImageComponent";
import "./BannerMarcas.css";

export default function BannerMarcas({ dados }) {
  if (!dados) return null;

  return (
    <section className="banner-marcas">
      {/* BANNER TOPO */}
      <div className="banner-topo">
        <img src={dados.banner1} alt="Variedade de produtos" />
      </div>

      {/* BANNER INFERIOR */}
      <div className="banner-inferior">
        <div className="banner-esquerda">
          {/* banner1 */}
          <img
            src={dados.banner2}
            alt={dados.nome}
          />
        </div>

        <div className="banner-direita">
          {/* titulo */}
          <h3>{dados.titulo}</h3>

          {/* descricao */}
          <p>{dados.descricao}</p>
        </div>
      </div>
    </section>
  );
}
